import { useQuery } from '@tanstack/react-query';
import { getUpsellOffer } from '../api/upsellOffer/getUpsellOffer';
import { UpsellOfferOrigin, OfferType } from '../@types/upsellOffer';

export const useGetUpsellOffer = (origin: UpsellOfferOrigin, type: OfferType, enabled: boolean = true) => {
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['upsell-offer', origin, type],
    queryFn: () => getUpsellOffer(origin, type),
    enabled,
  });

  return {
    initializing: isLoading || isFetching || isError,
    upsellOffer: data,
  };
};
